import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
    selector: 'kkis-app-webshop-nav-box1',
    templateUrl: './nav-box1.component.html',
    styleUrls: ['./nav-box1.component.scss']
})
export class NavBox1Component implements OnInit {

    /* -------------------------------*/
    /* NavBox with Mat-Selection-List */
    /* -------------------------------*/

    // Input
    @Input()
    title: string

    // Input:ReihenfolgeTree
    @Input()
    data: any[];

    @Input()
    displayPath: string; // anzeige

    @Input()
    valuePath: string; // wert

    @Input()
    isExpanded: boolean = false;

    @Input()
    minPreis: number;

    @Input()
    maxPreis: number;

    @Output()
    selectedOption: EventEmitter<string> = new EventEmitter<string>();

    selOption: string;

    // Settings
    public config: PerfectScrollbarConfigInterface = {};

    // Utils
    isLoading: boolean = true;

    constructor(
        private router: Router,
    ) { }

    ngOnInit(): void {

        console.log("minpreis/maxpreis => ", this.minPreis + ' / ' + this.maxPreis);

        this.title = this.title.toUpperCase();
        this.isLoading = false;
    }

    onNgModelchange(event) {

        console.log("event => ", event);

        this.router.navigate(['/articles'], {
            queryParams: {
                category: event[0].reihenfolgeWeb,
                minPreis: this.minPreis,
                maxPreis: this.maxPreis,
            }
        });
    }
}
